import { getCompanyColor } from './chartUtils';

const COMPANY_SUFFIX_RE = /\s+(life\s+insurance\s+company|insurance\s+company)\s*$/i;

/** Canonical brands and common SERFF / SEC short names → official site domain. */
const BRAND_DOMAIN_ENTRIES = [
  { keys: ['mutual of omaha insurance company', 'mutual of omaha'], domain: 'mutualofomaha.com' },
  { keys: ['massachusetts mutual life insurance company', 'massachusetts mutual', 'massmutual'], domain: 'massmutual.com' },
  { keys: ['metropolitan life insurance company', 'metropolitan life', 'metlife'], domain: 'metlife.com' },
  { keys: ['new york life insurance company', 'new york life', 'ny life'], domain: 'newyorklife.com' },
  { keys: ['the northwestern mutual life insurance company', 'northwestern mutual', 'northwestern'], domain: 'northwesternmutual.com' },
  { keys: ['transamerica life insurance company', 'transamerica'], domain: 'transamerica.com' },
  { keys: ['prudential financial', 'prudential'], domain: 'prudential.com' },
  { keys: ['pacific life insurance company', 'pacific life'], domain: 'pacificlife.com' },
  { keys: ['nationwide life insurance company', 'nationwide life', 'nationwide'], domain: 'nationwide.com' },
  { keys: ['john hancock life insurance company', 'john hancock'], domain: 'johnhancock.com' },
  { keys: ['jackson national life insurance company', 'jackson national'], domain: 'jackson.com' },
  { keys: ['lincoln national life insurance company', 'lincoln financial', 'lincoln national'], domain: 'lincolnfinancial.com' },
  { keys: ['guardian life insurance company', 'guardian life'], domain: 'guardianlife.com' },
  { keys: ['principal life insurance company', 'principal financial', 'principal'], domain: 'principal.com' },
  { keys: ['aflac incorporated', 'aflac'], domain: 'aflac.com' },
  { keys: ['unum group', 'unum'], domain: 'unum.com' },
  { keys: ['cigna corporation', 'cigna'], domain: 'cigna.com' },
  { keys: ['humana inc', 'humana'], domain: 'humana.com' },
  { keys: ['anthem inc', 'anthem', 'elevance health'], domain: 'elevancehealth.com' },
];

export function normalizeCompanyKey(name) {
  return String(name || '').trim().toLowerCase();
}

export function companyNamesMatch(a, b) {
  const left = normalizeCompanyKey(a);
  const right = normalizeCompanyKey(b);
  if (!left || !right) return false;
  return left === right || left.includes(right) || right.includes(left);
}

function resolveCompanyDomain(companyName) {
  const key = normalizeCompanyKey(companyName);
  if (!key) return null;

  for (const entry of BRAND_DOMAIN_ENTRIES) {
    const matched = entry.keys.some(
      (alias) => key === alias || key.includes(alias) || alias.includes(key),
    );
    if (matched) return entry.domain;
  }

  return null;
}

export function resolveCompanyLogoUrl(companyName, { size = 64 } = {}) {
  const domain = resolveCompanyDomain(companyName);
  if (!domain) return null;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=${size}`;
}

export function resolveCompanyBrand(companyName, { subjectCompany = '' } = {}) {
  const raw = String(companyName || '').trim();
  const displayName = raw.replace(COMPANY_SUFFIX_RE, '').trim() || raw;

  return {
    displayName,
    color: getCompanyColor(displayName || raw),
    logoUrl: resolveCompanyLogoUrl(raw),
    isClient: Boolean(subjectCompany) && companyNamesMatch(raw, subjectCompany),
  };
}
